/* import __COLOCATED_TEMPLATE__ from './ai-insights-addon-card.hbs'; */
/* RESPONSIBLE TEAM: team-self-serve */

import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { PERFORMANCE_PRO_BASE_ID } from 'embercom/lib/billing';
import type MarketingFeaturesService from 'embercom/services/marketing-features-service';

interface Signature {
  Element: HTMLElement;
  Args: {
    loading: boolean;
    isSelected: boolean;
    onToggle: () => void;
    price?: number;
  };
}

export default class AiInsightsAddonCard extends Component<Signature> {
  @service declare intl: any;
  @service declare marketingFeaturesService: MarketingFeaturesService;

  get aiInsightsFeatures(): Array<Array<{ text: string; tooltip?: string }>> {
    let categories = this.marketingFeaturesService.categories;
    let category = categories['performance_pro'];

    if (!category?.features) {
      return [[], []];
    }

    let allFeatures = this.marketingFeaturesService.getFeaturesByPlanId(
      Number(PERFORMANCE_PRO_BASE_ID),
    );

    let featuresArray = category.features
      .map((featureId) => allFeatures[featureId])
      .filter(Boolean)
      .map((feature) => ({
        text: feature.title,
        tooltip: feature.description,
      }));

    if (featuresArray.length === 0) {
      return [[], []];
    }

    let midpoint = Math.ceil(featuresArray.length / 2);
    let leftColumn = featuresArray.slice(0, midpoint);
    let rightColumn = featuresArray.slice(midpoint);

    return [leftColumn, rightColumn];
  }

  get aiInsightsSubcopyList() {
    return [
      {
        text: this.intl.t(`signup.teams.pricing5.annual-plans.upgrades.ai-insights.subcopy`),
      },
    ];
  }

  get aiInsightsHelpdeskArticleId() {
    return 13003501;
  }

  get price() {
    return this.args.price ?? 99;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Signup::Teams::Pricing5::Components::AiInsightsAddonCard': typeof AiInsightsAddonCard;
  }
}
